import React from 'react';

import { CaseResponseDto } from '@bandido/shared/dtos';

import { LinkCaseModal } from '@frontend/features/cases/components/LinkCaseModal';
import {
  ClientSelectorModal,
  ClientSelectorTableItem,
} from '@frontend/features/clients/components/ClientSelectorModal';
import { UserSelectorModal, UserSelectorTableItem } from '@frontend/features/users/components/UserSelectorModal';
import {
  OrganizationsSelectorModal,
  OrganizationsSelectorTableItem,
} from '@frontend/features/organizations/components/OrganizationSelectorModal';
import {
  AgenciesSelectorModal,
  AgenciesSelectorTableItem,
} from '@frontend/features/agencies/components/AgenciesSelectorModal';
import { TeamsSelectorModal, TeamsSelectorTableItem } from '@frontend/features/teams/components/TeamsSelectorModal';
import { CaseRenameModal } from '@frontend/features/cases/components/CaseRenameModal';

interface CaseViewModalsDesktopProps {
  caseData: CaseResponseDto | undefined;
  caseId: string;
  // LinkCaseModal props
  isLinkCaseOpen: boolean;
  onCloseLinkCase: () => void;
  // OrganizationsSelectorModal props
  isOrganizationEditOpen: boolean;
  onCloseOrganizationEdit: () => void;
  onSelectOrganization: (option: OrganizationsSelectorTableItem | null) => void;
  // AgenciesSelectorModal props
  isAgencyEditOpen: boolean;
  onCloseAgencyEdit: () => void;
  onSelectAgency: (option: AgenciesSelectorTableItem | null) => void;
  // ClientSelectorModal props
  isClientSelectorModalOpen: boolean;
  onCloseClientSelector: () => void;
  onSelectClient: (clientItem: ClientSelectorTableItem | null) => void;
  // UserSelectorModal props
  isAgentEditOpen: boolean;
  onCloseAgentSelector: () => void;
  onSelectAgent: (option: UserSelectorTableItem | null) => void;
  // TeamsSelectorModal props
  isTeamEditOpen: boolean;
  onCloseTeamSelector: () => void;
  onSelectTeam: (value: TeamsSelectorTableItem) => void;
  // CaseRenameModal props
  isCaseNameEditOpen: boolean;
  onCloseEditCaseName: () => void;
  onSaveCaseName: (value: string) => void;
}

export const CaseViewModalsDesktop: React.FC<CaseViewModalsDesktopProps> = ({
  caseData,
  caseId,
  isLinkCaseOpen,
  onCloseLinkCase,
  isOrganizationEditOpen,
  onCloseOrganizationEdit,
  onSelectOrganization,
  isAgencyEditOpen,
  onCloseAgencyEdit,
  onSelectAgency,
  isClientSelectorModalOpen,
  onCloseClientSelector,
  onSelectClient,
  isAgentEditOpen,
  onCloseAgentSelector,
  onSelectAgent,
  isTeamEditOpen,
  onCloseTeamSelector,
  onSelectTeam,
  isCaseNameEditOpen,
  onCloseEditCaseName,
  onSaveCaseName,
}) => {
  return (
    <>
      <LinkCaseModal isOpen={isLinkCaseOpen} fromCaseId={caseId} onClose={onCloseLinkCase} />
      
      {caseData?.agencyId && (
        <OrganizationsSelectorModal
          open={isOrganizationEditOpen}
          onClose={onCloseOrganizationEdit}
          agencyId={caseData.agencyId}
          onSelect={onSelectOrganization}
          selectedItemId={caseData.organizationId}
        />
      )}
      
      <AgenciesSelectorModal
        open={isAgencyEditOpen}
        onClose={onCloseAgencyEdit}
        onSelect={onSelectAgency}
        selectedItemId={caseData?.agencyId}
      />
      
      {caseData?.agencyId && (
        <ClientSelectorModal
          open={isClientSelectorModalOpen}
          onClose={onCloseClientSelector}
          agencyId={caseData.agencyId}
          onSelect={onSelectClient}
          selectedItemId={caseData.clientId}
        />
      )}
      
      {caseData && (
        <UserSelectorModal
          agencyId={caseData.agencyId}
          onSelect={onSelectAgent}
          open={isAgentEditOpen}
          onClose={onCloseAgentSelector}
          selectedItemId={caseData.agentId}
        />
      )}
      
      {caseData && (
        <TeamsSelectorModal
          agencyId={caseData.agencyId}
          onSelect={onSelectTeam}
          open={isTeamEditOpen}
          onClose={onCloseTeamSelector}
          selectedItemId={caseData.teamId}
        />
      )}
      
      {caseData && (
        <CaseRenameModal
          open={isCaseNameEditOpen}
          onClose={onCloseEditCaseName}
          onSave={onSaveCaseName}
          currentName={caseData.name}
        />
      )}
    </>
  );
};